
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';
import { getPopulateFields } from '@/modules/entity/api';
import { resolveEntityTypeFromFieldConfigAndFieldValue } from '@/modules/entity/utils';

export default {
  methods: {
    async getTriggerPopulationEntityType(fieldConfig, value) {
      return resolveEntityTypeFromFieldConfigAndFieldValue(fieldConfig, value);
    },
    fieldConfigByName(name) {
      if (isArray(this.config)) {
        const items = [];
        this.config.forEach(({ fieldsConfig }) => fieldsConfig.map(item => items.push(item)));
        return items.find(config => config.field === name) || null;
      }
      return this.config.fieldsConfig.find(config => config.field === name) || null;
    },
    async triggerPopulation({ fieldConfig, field, value }) {
      if (!value || (isArray(value) && isEmpty(value))) {
        return {};
      }
      const type = await this.getTriggerPopulationEntityType(fieldConfig, value);
      if (!type) {
        return {};
      }
      const id = isObject(value) ? value.id : value;
      const fields = await getPopulateFields(id, type, {
        triggerPopulationField: field,
        contextEntity: this.entity || null,
        contextEntityId: this.entityId || null,
        draft: this.draft,
        wizard: this.entity,
      });
      return Object.keys(fields)
        // Filter the fields to be populated by config
        // Ignore fields configured as "ignorePopulation"
        .filter((key) => {
          if (field === key) {
            return true;
          }
          const config = this.fieldConfigByName(key);
          if (!config) {
            return false;
          }
          return config.ignorePopulation !== true;
        })
        .reduce((result, key) => {
          result[key] = fields[key];
          return result;
        }, []);
    },
  },
};
